module.exports = __webpack_public_path__ + "images/category_lp/furniture/assessment_achievements/2_f74a990228d57ac87a529726f7bfc668.png";